import type { MaintenanceTask } from '@/types/maintenanceTask'

// In-memory sample worklist for the My List tab (mock phase). Due dates are
// relative to today so "Today" / "Overdue" render correctly in any demo.

function iso(offsetDays: number): string {
  const d = new Date()
  d.setDate(d.getDate() + offsetDays)
  return d.toISOString().slice(0, 10)
}

const ACTIVE: MaintenanceTask[] = [
  {
    id: 'mt-1',
    taskClass: 'preventive',
    equipmentId: 'Apheresis machine-A2',
    usedBy: 'Production',
    eventType: 'calibration',
    priority: 3,
    earlyStart: '2026-07-05',
    dueDate: iso(0),
    planHours: 2.0,
    assigned: 'Paul P',
    status: 'due',
  },
  {
    id: 'mt-2',
    taskClass: 'corrective',
    equipmentId: 'Plasma separators-A1',
    usedBy: 'Production',
    eventType: 'corrective_maintenance',
    priority: 2,
    dueDate: iso(0),
    planHours: 1.5,
    assigned: 'Paul P',
    status: 'started',
  },
  {
    id: 'mt-3',
    taskClass: 'preventive',
    equipmentId: 'CO₂ incubators-A1',
    usedBy: 'Cell Culture',
    eventType: 'inspection',
    priority: 3,
    earlyStart: '2026-07-06',
    dueDate: iso(0),
    planHours: 1.0,
    assigned: 'Paul P',
    status: 'due',
  },
  {
    id: 'mt-4',
    taskClass: 'preventive',
    equipmentId: 'Biosafety cabinet-A1',
    usedBy: 'Cell Proc.',
    eventType: 'verification',
    priority: 4,
    earlyStart: '2026-07-02',
    dueDate: iso(-3),
    planHours: 0.5,
    assigned: 'Paul P',
    status: 'overdue',
    overdue: true,
    daysOverdue: 3,
  },
  // Started and late: still overdue, and still offers End rather than Start.
  {
    id: 'mt-8',
    taskClass: 'preventive',
    equipmentId: 'Cryo freezers-B1',
    usedBy: 'Cryo',
    eventType: 'calibration',
    priority: 2,
    dueDate: iso(-5),
    planHours: 2.0,
    assigned: 'Paul P',
    status: 'started',
    overdue: true,
    daysOverdue: 5,
  },
  {
    id: 'mt-5',
    taskClass: 'corrective',
    equipmentId: 'Centrifuges-A1',
    usedBy: 'Cell Proc.',
    eventType: 'corrective_maintenance',
    priority: 2,
    dueDate: iso(0),
    planHours: 1.0,
    assigned: 'Paul P',
    status: 'started',
  },
  {
    id: 'mt-6',
    taskClass: 'preventive',
    equipmentId: 'Fill-finish line-B2',
    usedBy: 'Filling',
    eventType: 'preventive_maintenance',
    priority: 5,
    earlyStart: iso(0),
    dueDate: iso(1),
    planHours: 3.0,
    assigned: 'Paul P',
    status: 'due',
  },
  {
    id: 'mt-7',
    taskClass: 'preventive',
    equipmentId: 'Laminar flow hoods-A1',
    usedBy: 'Cell Proc.',
    eventType: 'cleaning',
    priority: 3,
    dueDate: iso(0),
    planHours: 0.75,
    assigned: 'Paul P',
    status: 'due',
  },
]

// A week of completed history (feeds the "Completed · wk" stat).
const COMPLETED: MaintenanceTask[] = Array.from({ length: 12 }, (_, i) => {
  const eventTypes = ['preventive_maintenance', 'cleaning', 'calibration', 'inspection', 'verification']
  const equipment = [
    'Cryo freezers-A1',
    'LN2 storage tanks-A1',
    'Orbital shakers-A1',
    'Tube sealers-A1',
    'Barcode printers-A1',
    'Spinner flasks-A1',
  ]
  return {
    id: `mt-c${i + 1}`,
    taskClass: (i % 4 === 0 ? 'corrective' : 'preventive') as MaintenanceTask['taskClass'],
    equipmentId: `${equipment[i % equipment.length]}`,
    usedBy: ['Production', 'Cell Culture', 'Cell Proc.', 'Cryo'][i % 4],
    eventType: i % 4 === 0 ? 'corrective_maintenance' : eventTypes[i % eventTypes.length],
    priority: (i % 5) + 1,
    dueDate: iso(-1 - (i % 6)),
    planHours: [0.5, 1, 1.5, 2, 3][i % 5],
    assigned: 'Paul P',
    status: 'completed',
    // One ran late, so the marker has a row to show on.
    completedLate: i === 0,
  }
})

export const mockMaintenanceTasks: MaintenanceTask[] = [...ACTIVE, ...COMPLETED]
